import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const ComingSoon = () => {
  return (
    <>
      <Navbar />
      <main id="main-content" className="bg-white overflow-hidden">

      {/* Hero. Solid brand-primary rather than a gradient into white: a gradient
          leaves the exact background color under the text undecidable (and, near
          the white end, this text would actually fail contrast), so a flat color
          keeps the same royal-blue hero look with a guaranteed-readable result. */}
      <section className="relative min-h-[70vh] pt-24 md:pt-32 pb-12 md:pb-20 band-light text-brand-text-primary overflow-hidden">
        <div className="content-container relative z-10">
          <div className="max-w-3xl mx-auto text-center">
            <div className="inline-block bg-white shadow-sm border border-brand-primary/20 px-6 py-3 text-sm font-medium tracking-wider mb-8">
              Coming Soon
            </div>
            <h1 className="text-display font-display mb-6">Something Wonderful Is In The Works</h1>
            <p className="text-body text-lg leading-relaxed">
              We’re crafting this page to better serve our community of authors. Check back soon for updates.
            </p>
          </div>
        </div>
        <div aria-hidden="true" className="absolute inset-0 opacity-20 pointer-events-none overflow-hidden">
          <div className="absolute top-10 md:top-20 left-10 md:left-20 w-20 md:w-32 h-20 md:h-32 border-2 border-brand-primary/30 rounded-full"></div>
          <div className="absolute bottom-20 right-20 w-16 md:w-24 h-16 md:h-24 border-2 border-brand-primary/30 rounded-full"></div>
        </div>
      </section>

      {/* Info/CTA */}
      <section className="section-padding bg-white">
        <div className="content-container">
          <div className="max-w-4xl mx-auto text-center">
            <p className="text-body mb-8">
              In the meantime, explore our latest news, programs, and resources, or reach out to us directly.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a href="/" className="inline-flex items-center px-8 py-4 bg-brand-primary text-white font-medium hover:bg-brand-secondary transition-all duration-300">
                Back to Home
              </a>
              <a href="/contact" className="inline-flex items-center px-8 py-4 border border-brand-primary text-brand-primary font-medium hover:bg-brand-primary hover:text-white transition-all duration-300">
                Contact Us
              </a>
            </div>
          </div>
        </div>
      </section>

      </main>
      <Footer />
    </>
  );
};

export default ComingSoon;


